export interface StatusUser {
  statusUser: Array<{
    text: string,
    value: string,
  }>
}

export function getStatusUser(): StatusUser {
  return {
    statusUser: [
      { text: 'ไม่ระบุ', value: 'ไม่ระบุ' },
      { text: 'โสด', value: 'โสด' },
      { text: 'สมรส', value: 'สมรส' },
      { text: 'หย่าร้าง', value: 'หย่าร้าง' },
      { text: 'หม้าย', value: 'หม้าย' },
      { text: 'เสียชีวิต', value: 'เสียชีวิต' },
    ],
  }
}
